if (!customElements.get('rm-delivery-upsell')) {
  customElements.define('rm-delivery-upsell', class RmDeliveryUpsell extends HTMLElement {
    constructor() {
      super();
  
      // Prices are in pence
      this.threshold = parseInt(this.getAttribute('data-threshold'));
      this.total = this.getAttribute('data-total');
  
      this.setupDisplay(this.total);
    }
  
    calculatePriceDifference(total) {
      return ((this.threshold - total) / 100).toFixed(2);
    }

    recalculateAfterDiscounts() {
      const deliveryUpsell = this;

      if (typeof jQuery !== 'undefined') {
        jQuery( document ).ajaxComplete(() => {
          if (window.booster && (window.booster.discounts && window.booster.discounts.discounted_price)) {
            deliveryUpsell.setupDisplay(window.booster.discounts.discounted_price * 100);
          } 
        })
      }
    }
  
    setupDisplay(total) {
  
      this.recalculateAfterDiscounts();

      const percentage = (total / this.threshold) * 100;
      const textElements = document.querySelectorAll('.rm-delivery-upsell-txt');
      const progressBars = document.querySelectorAll('.rm-delivery-upsell-progressbar');
  
      progressBars.forEach(bar => {
        bar.style.width = percentage + '%';
      });
  
      textElements.forEach(element => {
        if(total > this.threshold) {
            element.innerHTML = window.cartStrings.rmDeliveryUpsellQualifies;
            element.classList.remove('rm-delivery-upsell-under')
            element.classList.add('rm-delivery-upsell-over')
        } else {
            element.innerHTML = `Spend <span class="rm-delivery-upsell-value">£${this.calculatePriceDifference(total)}</span> more to qualify for free delivery`;
            element.classList.remove('rm-delivery-upsell-over')
            element.classList.add('rm-delivery-upsell-under')
        }
      })
  
    }
  
    // Triggered from the cart update post request in product-form.js
    async updateDisplay() {
  
      // Get localized cart URL to ensure correct currency data
      let cartUrl = '/cart.js';
      const currentPath = window.location.pathname;
      const localeMatch = currentPath.match(/^\/([a-z]{2}-[a-z]{2})\//);
      
      if (localeMatch && localeMatch[1] !== 'en-GB') {
        cartUrl = `${localeMatch[0]}cart.js`;
      }
  
      const response = await fetch(cartUrl)
  
      if (!response.ok) {
        const message = `An error has occured: ${response.status}`;
        throw new Error(message);
      }
  
      const data = await response.json();
      this.total = data.total_price
      this.setupDisplay(this.total)
  
    }
  
  });
}